<template>
  <v-navigation-drawer
    id="default-drawer"
    v-model="drawer"
    :dark="dark"
    :right="$vuetify.rtl"
    :src="drawerImage ? image : ''"
    :mini-variant="mini"
    mini-variant-width="80"
    width="260"
    app
  >
    <template
      v-if="drawerImage"
      #img="props"
    >
      <v-img
        :key="image"
        :gradient="gradient"
        v-bind="props"
      />
    </template>

    <div class="px-2">
      <default-drawer-header />

      <v-divider class="mx-3 mb-2" />

      <default-list
        v-if="hasSales"
        :items="salesItems"
      />

      <default-list
        v-if="hasInvoices"
        :items="invoiceItems"
      />

      <v-divider
        v-if="hasSales || hasInvoices"
        class="mx-3 mb-2"
      />

      <default-list
        v-if="hasSalesTeam"
        :items="salesTeamItems"
      />

      <default-list
        v-if="hasAllInvoices"
        :items="allInvoicesItems"
      />

      <v-divider
        v-if="(hasAllInvoices || hasSalesTeam) && openSales.length == 0"
        class="mx-3 mb-2"
      />

      <v-divider
        v-if="openSales.length > 0"
        class="mx-3 mb-2 primary"
      />

      <v-divider
        v-if="openSales.length > 0"
        class="mx-3 mb-2 primary"
      />

      <default-list
        v-if="openSales.length > 0"
        class="outline"
        :items="openSales"
      />

      <v-divider
        v-if="openSales.length > 0"
        class="mx-3 mb-2"
      />
    </div>

    <template #append>
      <div class="pa-4 text-center" />
    </template>

    <div class="pt-12" />
  </v-navigation-drawer>
</template>

<script>
// Utilities
  import { get, sync } from 'vuex-pathify'

  export default {
    name: 'DefaultDrawer',

    components: {
      DefaultDrawerHeader: () =>
      import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader'
      ),
      DefaultList: () =>
      import(
        /* webpackChunkName: "default-list" */
        './List'
      ),
    },

    computed: {
      ...get('user', ['dark', 'gradient', 'image']),
      ...get('app', ['items', 'version']),
      ...get('app', [
        'salesItems',
        'hasSales',
        'invoiceItems',
        'hasInvoices',
        'salesTeamItems',
        'hasSalesTeam',
        'allInvoicesItems',
        'hasAllInvoices',
        'openSales',
      ]),
      ...sync('app', ['drawer', 'drawerImage', 'mini']),
    },
  }
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important
</style>
